export const ACCRUAL_BASE_TYPE_EUROS = '€'

export const ACCRUAL_BASE_TYPE_PERCENTAGE = '%'
